export default __webpack_public_path__ + "static/20922-Menu-PCS-8677e760da1c406963d17bec342ef011.jpg";